<template>
  <div data-qa="price_club">
    <div class="d-flex align-center gc-3">
      <div
        class="text-h6 error--text d-flex align-center gc-1 mb-1"
        data-qa="price_club_num"
      >
        {{ getFormattedPrice(clubPrice) }}
        <img
          :alt="t('Иконка Процент Клуба', options)"
          src="/static/_v1/pd/icons/ui-kit/club/club-percent.svg"
          width="20"
          height="20"
        >
      </div>
      <div
        class="text-body-2 text-secondary--text text-decoration-line-through mb-1"
        data-qa="price_club_orig_num"
      >
        {{ getFormattedPrice(price) }}
      </div>
    </div>
    <div class="d-flex align-center gc-3">
      <div
        class="text-caption error--text"
        data-qa="price_club_desc"
      >
        {{ t('Клубная цена', options) }}
      </div>
      <div
        data-qa="price_club_more"
        class="text-caption text-secondary--text d-flex align-start cursor-pointer pa-1 ma-n1"
        @click="$emit('click:show-info')"
      >
        {{ t('Подробнее о цене', options) }}
        <div class="ui-icon-arrow-right ui-icon-fz-smaller icon-secondary--text" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import { getFormattedPrice } from 'www/utils'

const { t, language } = I18NextVue
const options = { ns: language }

defineProps<{
  price?: number | null
  clubPrice?: number | null
}>()

defineEmits(['click:show-info'])
</script>
